import { GridButton } from '@eforall/dashboard';
import { AccApplicationDialogDataService } from '../../acc-application-dialog-data.service';



export function getButtons(accApplDialogDataService: AccApplicationDialogDataService) {

	const buttons: GridButton[] = [
		{
			iconClass: 'fa-refresh',
			label: 'Refresh',
			execute: async () => {
				await accApplDialogDataService.reloadData();
			}
		},
	];

	return buttons;
}